/**
 * Related-articles slider (sections/related-articles.liquid) — D-22.
 *
 * Live ships this logic as an inline <script> per section instance, keyed to
 * document.querySelector('#<section.id>'). The rebuild keeps JS in plain
 * asset scripts (no ES modules): the section marks its root with
 * [data-related-articles-slider] and this file wires every instance.
 * Behaviour is live's, unchanged:
 *   - prev/next buttons scroll the strip by one item width
 *     (total scrollWidth / child count, live's own step math);
 *   - the .slider__footer-nav-step delegation is carried verbatim even
 *     though live never renders that footer markup (the handler can never
 *     fire) — kept so the port diffs clean against the source.
 * Live's duplicate #slider-* ids are kept in the markup; lookups here are
 * scoped to the instance root, so multiple instances behave like live's
 * (first-match) — better, per-instance — without changing the DOM.
 */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-related-articles-slider]').forEach((slider) => {
    const nextBtn = slider.querySelector('#slider-next');
    const prevBtn = slider.querySelector('#slider-prev');
    const sliderContainer = slider.querySelector('#slider-items');
    if (!nextBtn || !prevBtn || !sliderContainer) return;

    const sliderWidth = sliderContainer.scrollWidth;
    const sliderItemsCount = sliderContainer.childElementCount;
    const sliderItemWidth = sliderWidth / sliderItemsCount;
    const stepIndicator = slider.querySelector('.slider__footer-nav-step-indicator');

    nextBtn.addEventListener('click', () => {
      slider.querySelector('.overflow-x-scroll').scrollBy({
        top: 0,
        left: sliderItemWidth,
        behavior: 'smooth'
      });
    });

    prevBtn.addEventListener('click', () => {
      slider.querySelector('.overflow-x-scroll').scrollBy({
        top: 0,
        left: -sliderItemWidth,
        behavior: 'smooth'
      });
    });

    slider.querySelectorAll('.slider__footer-nav-step').forEach(() => {
      slider.addEventListener('click', (e) => {
        if (e.target.classList.contains('slider__footer-nav-step')) {
          const index = e.target.dataset.index;
          slider.querySelector('.overflow-x-scroll').scrollTo({
            top: 0,
            left: (sliderContainer.offsetWidth * index),
            behavior: 'smooth'
          });
          stepIndicator.style.left = `${index * stepIndicator.offsetWidth}px`;
        }
      });
    });
  });
});
